import { Star, Quote } from "lucide-react";
import { testimonials } from "@/content/siteContent";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export default function Testimonials() {
  return (
    <section className="bg-cream py-24 md:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          light
          chapter={testimonials.chapter}
          microtitle={testimonials.microtitle}
          titleA={testimonials.titleA}
          titleB={testimonials.titleB}
        />

        <div className="grid gap-5 md:grid-cols-3">
          {testimonials.items.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <figure className="card-industrial flex h-full flex-col p-7" data-testid={`testimonial-card-${i + 1}`}>
                <Quote className="h-6 w-6 text-brand" strokeWidth={1.5} />
                <div className="mt-4 flex gap-1" aria-label={`Avaliação ${t.rating} de 5`}>
                  {Array.from({ length: t.rating }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-brand text-brand" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-mist">“{t.text}”</blockquote>
                <figcaption className="mt-6 border-t border-metal pt-4">
                  <p className="font-display text-sm font-extrabold text-paper">{t.name}</p>
                  <p className="mt-0.5 text-xs tracking-wide text-brand">{t.service}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
